import {TipoOperazione} from '../_helpers/TipoOperazione';
import {TipoFormControl} from '../_helpers/TipoFormControl';

// Voce di un select filtrabile: `value` finisce in FilterItem.value1 (che il backend
// deserializza come stringa), `text` e' l'etichetta mostrata. E' ammesso il numero perche'
// alcuni select espongono valori numerici — vedi onColumnSelectValueChange in
// OrdiniFilterRowComponent, che normalizza comunque a stringa.
export interface FilterOption {
  value: string | number;
  text: string;
}

export class FilterItem {
  fieldName: string;
  operazione: TipoOperazione;
  value1: string;
  value2: string;
  tipoFormControl: TipoFormControl;
  options?: FilterOption[];
  showColumn: boolean;
  // Etichetta mostrata nel pannello filtri su mobile. Se assente si usa la mappa per fieldName in OrdiniFilterRowComponent, con fallback sul fieldName stesso.
  label?: string;
}
